import styled from 'styled-components';
import { Nest } from 'ui/icons/action/Nest';
import { colors, spacing } from 'ui/theme';

import { useTranslation } from '../../../hooks/useTranslation';
import { ConditionValue } from '../conditionValue';
import {
  ComparatorSelect,
  ContactPropertySelect,
  EventPropertySelect,
  EventSelect,
} from '../selects';
import { useIsEventOption, useIsNoOptionSelected } from '../selects/hooks';
import { useIsUserOption } from '../selects/hooks/useIsUserOption';
import { TriggerEventTooltip } from '../selects/TriggerEventTooltip';

const StyledNest = styled(Nest)`
  position: absolute;
  left: ${({ theme }) => theme.spacing.utils.pxToRem(-25)};
  top: ${({ theme }) => theme.spacing.utils.pxToRem(10)};
`;

const SelectWrapper = styled.div<{ $isEventOption: boolean }>`
  align-items: center;
  position: relative;
  display: flex;
  flex-direction: row;
  column-gap: ${spacing.half};
  ${({ $isEventOption, theme }) =>
    $isEventOption &&
    `
    margin-left: ${theme.spacing.utils.pxToRem(40)};
  `};
`;

const StyledText = styled.span`
  ${({ theme }) => theme.styles.body.body1};
  width: fit-content;
  color: ${({ theme }) => theme.colors.textColors.textSecondary};
`;

const FormWrapper = styled.div<{ $isEventOption: boolean }>`
  align-items: center;
  ${({ $isEventOption, theme }) =>
    $isEventOption
      ? `
      display: flex;
      row-gap: ${theme.spacing.values.threeQuarter};
      flex-direction: column;
      position: relative;
      align-items: flex-start;
      position: relative;
    `
      : `
      display: flex;
      flex-direction: row;
      column-gap: ${spacing.half};
  `};
`;

const EventSelectWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: ${spacing.half};
`;

export const DATA_TEST = {
  wrapper: 'property-wrapper',
  icon: 'event-property-icon',
};

export const PropertyForm = () => {
  const { t } = useTranslation();
  const isNoOptionSelected = useIsNoOptionSelected();
  const isEventOption = useIsEventOption();
  const isUserOption = useIsUserOption();
  const showEventSelect = !isUserOption || isEventOption;

  return (
    <FormWrapper $isEventOption={isEventOption} data-test={DATA_TEST.wrapper}>
      <ContactPropertySelect />
      {isNoOptionSelected && <StyledText>{t('selector.option.or')}</StyledText>}
      {showEventSelect && (
        <EventSelectWrapper>
          <EventSelect />
          {isEventOption && <TriggerEventTooltip />}
        </EventSelectWrapper>
      )}
      <SelectWrapper $isEventOption={isEventOption}>
        {isEventOption && <StyledNest color={colors.textSecondary} data-test={DATA_TEST.icon} />}
        {isEventOption && <EventPropertySelect />}
        <ComparatorSelect />
        <ConditionValue />
      </SelectWrapper>
    </FormWrapper>
  );
};
